// extracted by mini-css-extract-plugin
export default {"app":"a047aad50f5e"};